import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { useContext } from 'react'
import { SessionContext } from 'contexts/session'

/**
 * Energy Segment Detail data
 * @param {string} stationCode
 * @param {number} blockIndex
 * @returns UseQueryResult
 */
const useEnergySegmentDetailsQuery = () => {
  const { stationCode, blockIndex, centipedeLineupId, energySegmentId } =
    useParams()
  const { session } = useContext(SessionContext)

  return useQuery(
    [
      'energySegmentDetails',
      stationCode,
      blockIndex,
      centipedeLineupId,
      energySegmentId,
    ],
    async () => {
      const apiUrl = session.server
      const axiosOptions = {
        headers: {
          Accept: 'application/json',
          papitoken: session.token,
        },
      }

      const response = await axios.get(
        `${apiUrl}station/${stationCode}/block/${blockIndex}/centipedelineups/${centipedeLineupId}/energysegments/${energySegmentId}/status`,
        axiosOptions,
      )
      return response.data
    },
    { refetchInterval: 5000 },
  )
}

export default useEnergySegmentDetailsQuery
